let firstTimeUser= false;

export function getFirstTimeStatus(){
    return firstTimeUser;
}

export function setFirstTimeUser(value){
    firstTimeUser= value;
}